﻿
import React from 'react';
import { HtmlOutput } from './HtmlOutput'

export const Error = (props) => {
  const wrappingClass = ['single-step__section', 'single-step__section--error'];

  if (props.modifierClass)
    wrappingClass.push('single-step__section--' + props.modifierClass);

  if (props.children)
    wrappingClass.push('single-step__section--flex');

  return (
    <div className={wrappingClass.join(' ')}>
      { props.text && <p><HtmlOutput html={props.text} /></p> }
      { props.children }
    </div>
  )
}
